import React from 'react';
import logo from './logo.svg';
import './App.css';
import Typing from 'react-typing-animation';

function Home() {
    
  return (
        <div>
        <div>
          <img src={logo} className="App-logo" alt="logo" />
        </div>

        <div>
          <Typing speed={50}>
            <p>Hey! Im Boris</p>
            <p> Software Engineer at <a href="https://www.justcode.com">JustCode</a> and <a href="https://turntotech.io/">TurnToTech</a> </p>
          </Typing>
        </div>
        </div>

  );
}

export default Home;
